import { render } from "./MergeReceipt.vue?vue&type=template&id=327a5906"
const script = {}

import exportComponent from "/Users/Chiche/Projects/mekiotech/authorizer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__